import { STORE_DETAIL,STORE_DETAIL_CLEAR } from "./actionTypes";

const defaultState = {
  storeDetail: [],
};

export const reducer = (state = defaultState, action) => {
  const { type, storeDetail } = action;
  switch (type) {
    case STORE_DETAIL:
      return {
        ...state,
        storeDetail: storeDetail,
      };
      case STORE_DETAIL_CLEAR:
        return{
           ...state,
           storeDetail:storeDetail
        }

    default:
      return state;
  }
};

export default reducer;
